<template>
  <div class="code">
    <div class="code-container">
      <div class="code-header">
          <div class="search-box"></div>
          <div class="operation-box">
              <el-button  type="primary" @click="addQunCode">新增企微群活码</el-button>
          </div>
      </div>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="二维码" width="120">
          <template slot-scope="scope">
            <div class="code-preview">
              <el-image :src="scope.row.url"></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="群名称" min-width="100">
        </el-table-column>

        <el-table-column prop="scanNum" label="扫码次数" min-idth="80">
        </el-table-column>
        <el-table-column label="可加入的群聊" min-width="150">
          <template slot-scope="scope">
            <div class="qun-list">
              <div class="qun-item"><span class="first">群名称</span><span>|</span><span>群主:吴明岩</span></div>
              <div class="qun-item"><span class="first">群名称</span><span>|</span><span>群主:吴明岩</span></div>
              <div class="qun-item"><span class="first">群名称</span><span>|</span><span>群主:吴明岩</span></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="已关联群机器人" min-width="100">
        </el-table-column>
        <el-table-column prop="type" label="类型" min-width="80">
        </el-table-column>
        <el-table-column label="标签" min-width="200">
          <template slot-scope="scope">
            <div class="code-tag">
              <el-tag
                v-for="item in scope.row.items"
                :key="item.label"
                :type="item.type"
                size="mini"
                effect="dark"
              >
                {{ item.label }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="120">
          <template slot-scope="scope">{{ scope.row.date }}</template>
        </el-table-column>
        <el-table-column label="操作" min-width="180">
          <template slot-scope="scope">
            <el-button @click="editQunCode()" type="text"
              >编辑</el-button
            >
            <el-button type="text" size="small">通知使用者</el-button>
            <el-button type="text" size="small">下载二维码</el-button>
            <el-button type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 添加编辑活码抽屉 -->
    <el-drawer
      :title="codeDrawerTitle"
      :visible.sync="editCodeDrawer"
      size="60%"
      direction="rtl">
      <div>
      <div class="drawer-container">
        <div class="drawer-form-content">
          <el-form :model="form">
            <el-form-item label="活码名称" label-width="120px">
              <el-input v-model="form.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="活码类型" label-width="120px">
              <el-select v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="关联群机器人" label-width="120px">
              <el-select v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="可加入的群聊" label-width="120px">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  选择群聊<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item><div class="add-qun" @click="addQundialogFormVisible = true">新建群聊</div></el-dropdown-item>
                  <el-dropdown-item><div class="add-qun" @click="selectQunDialogVisible = true">选择已有群聊</div></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-form-item>
            <el-form-item label="标签" label-width="80px">
              <div class="form-tag">
                <el-tag
                  v-for="item in items"
                  :key="item.label"
                  :type="item.type"
                  effect="dark">
                  {{ item.label }}
                </el-tag>
                <el-button size="mini" type="primary" icon="el-icon-plus">添加标签</el-button>
              </div>
            </el-form-item>
            <el-form-item label="欢迎语" label-width="80px">
              <div class="welcome-content">
                <div class="welcome-status">
                  <el-switch
                    v-model="welcomeStatus"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
                  </el-switch>
                  <el-select v-model="selectedWelcomeContent" filterable placeholder="选择已有欢迎语">
                    <el-option
                      v-for="item in form.options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="welcome-config">
                  <div class="welcome-config-textarea">
                    <el-input
                      type="textarea"
                      placeholder="请输入文本欢迎语内容，最多1000个字"
                      v-model="textarea"
                      maxlength="1000"
                      show-word-limit
                    >
                    </el-input>
                  </div>
                  <div class="welcome-config-other">
                     <el-link @click="materialDialogVisible = true" :underline="false" slot="reference" type="info" style="color:#409eff;"><em class="el-icon-plus"></em>素材库中添加</el-link>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="drawer-preview">
            <div class="business-card-template-preview-content">
                    <div class="chatbot-box">
                        <div class="chatbot-title gray">
                            <div class="chatbot-title-text">对话窗</div>
                        </div>
                        <div class="chatbot-content">
                            <div class="message-box">
                                <div class="chatbot-message">
                                    <p>{{textarea}}</p>
                                </div>
                            </div>
                            <!-- <div class="message-box-user">
                                <div class="user-message">
                                    <p>单位</p>
                                </div>
                            </div> -->
                        </div>
                        
                    </div>
                <span style="font-size:18px;text-align:center;margin-left:100px">欢迎语预览</span>
                </div>

                <div class="code-preview-download">
                    <el-image style="height:200px;width:200px" src="https://wwcdn.weixin.qq.com/node/wework/mobilekit/images/202005091515.bdc7d40604.png"></el-image>
                    <span style="margin-top:15px">二维码预览</span>
                </div>
        </div>
      </div>
      <div slot="footer" class="drawer-footer">
          <el-button @click="addTagDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addTagDialogVisible = false">确 定</el-button>
      </div>
      </div>
    </el-drawer>
    <!-- 选择素材 -->
    <el-dialog
      title="选择素材"
      :visible.sync="materialDialogVisible"
      :close-on-click-modal="false"
      width="60%"
      top="4vh"
    >
      <div>
        <Material></Material>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="materialDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="materialDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 新建群聊 -->
    <el-dialog title="新增群聊" :close-on-click-modal="false" :visible.sync="addQundialogFormVisible" width="30%">
      <el-form :model="addQunInfo">
        <el-form-item label="群主" label-width="80px">
          <el-cascader :options="addQunInfo.owner" :show-all-levels="false"></el-cascader>
        </el-form-item>
        <el-form-item label="群名称" label-width="80px">
          <el-input v-model="addQunInfo.name" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addQundialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addQundialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 选择群聊 -->
    <el-dialog
      title="选择群聊"
      :close-on-click-modal="false"
      :visible.sync="selectQunDialogVisible"
      width="40%">
      <div class="select-qun-box">
        <div class="qun-list">
          <div class="search-box">
            <el-input size="small" v-model="searchQunName" placeholder="群输入群主或群名称"></el-input>
            <el-button size="small" type="primary" icon="el-icon-search">搜索</el-button>
          </div>
          <div class="qun-content">
            <div class="qun-item qun-item-header">
              <div class="name">群聊名称1</div>
              <div class="owner">吴明岩</div>
            </div>
            <div class="qun-item">
              <div class="name">群聊名称1</div>
              <div class="owner">吴明岩</div>
            </div>
            <div class="qun-item">
              <div class="name">群聊名称1</div>
              <div class="owner">吴明岩</div>
            </div>
          </div>
        </div>
        <div class="selected-qun-list">
          <div class="qun-content">
            <div class="qun-item qun-item-header">
              <div class="name">已选择群</div>
              <div class="owner">群主</div>
              <em></em>
            </div>
            <div class="qun-item">
              <div class="name">群聊名称1</div>
              <div class="owner">吴明岩</div>
              <em class="el-icon-close"></em>
            </div>
            <div class="qun-item">
              <div class="name">群聊名称1</div>
              <em class="el-icon-close"></em>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="selectQunDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="selectQunDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Material from "./../../components/materialSelection"
export default {
  name: "",
  components: {Material},
  data() {
    return {
      tableData: [
        {
          url:
            "http://bpic.588ku.com/element_origin_min_pic/01/37/28/96573c450260f4c.jpg",
          name: "官网引流",
          scan: "123",
          member: "zhangshan lisi",
          type: "二维码/立牌/小程序",
          items: [
            { type: "", label: "标签一" },
            { type: "success", label: "标签二" },
            { type: "info", label: "标签三" },
            { type: "danger", label: "标签四" },
            { type: "warning", label: "标签五" },
          ],
          date: "2016-05-03 14:23:23",
        },
      ],
      codeDrawerTitle: '',
      editCodeDrawer: false,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
        props: { multiple: true },
        options: [{
          value: 1,
          label: '东南',
          children: [{
            value: 2,
            label: '上海',
            children: [
              { value: 3, label: '普陀' },
              { value: 4, label: '黄埔' },
              { value: 5, label: '徐汇' }
            ]
          }, {
            value: 7,
            label: '江苏',
            children: [
              { value: 8, label: '南京' },
              { value: 9, label: '苏州' },
              { value: 10, label: '无锡' }
            ]
          }, {
            value: 12,
            label: '浙江',
            children: [
              { value: 13, label: '杭州' },
              { value: 14, label: '宁波' },
              { value: 15, label: '嘉兴' }
            ]
          }]
        }, {
          value: 17,
          label: '西北',
          children: [{
            value: 18,
            label: '陕西',
            children: [
              { value: 19, label: '西安' },
              { value: 20, label: '延安' }
            ]
          }, {
            value: 21,
            label: '新疆维吾尔族自治区',
            children: [
              { value: 22, label: '乌鲁木齐' },
              { value: 23, label: '克拉玛依' }
            ]
          }]
        }]
      },
      // 活码标签
      items: [
          { type: '', label: '标签一' },
          { type: 'success', label: '标签二' },
          { type: 'info', label: '标签三' },
          { type: 'danger', label: '标签四' },
          { type: 'warning', label: '标签五' }
      ],
      welcomeStatus: true,
      selectedWelcomeContent: '',
      textarea: '',
      materialDialogVisible: false,
      addQundialogFormVisible: false, //新建群聊 
      addQunInfo: {
        owner: '',
        name: ''
      },
      selectQunDialogVisible: false,
      searchQunName: '',
    };
  },
  methods: {
    addQunCode() {
      this.codeDrawerTitle = '新增企微群活码';
      this.editCodeDrawer = true
    },
    editQunCode() {
      this.codeDrawerTitle = '编辑企微群活码';
      this.editCodeDrawer = true
    },
    uploadComplate(response, file, fileList){
      console.log(response, file, fileList);
    },
    handleSelectionChange(){

    }
  },
};
</script>

<style lang="less">
@import url("../../assets/less/leadsSource/dynamicCodeQun.less");
</style>